import React from 'react';
import { Empty } from 'antd';
import { EmptyStateContainer } from '../../styled';
import OrderCardComponent from "../../OrderCard";
import TablePagination from '../TablePagination';
import usePagination from '../../usePagination';

const UnfulfilledOrdersSection = ({ 
  orders, 
  onFulfill, 
  onView, 
  onViewFulfillment 
}) => {
  const {
    paginatedData,
    currentPage,
    pageSize,
    total,
    handlePageChange,
    handlePageSizeChange
  } = usePagination(orders);

  return (
    <>
      {orders.length > 0 ? (
        <>
          {paginatedData.map((order) => (
            <OrderCardComponent
              key={order._id}
              order={order}
              onUpdateStatus={onFulfill}
              onViewOrder={onView}
              onViewFulfillment={onViewFulfillment}
            />
          ))}
          
          <TablePagination
            current={currentPage}
            pageSize={pageSize}
            total={total}
            onChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </>
      ) : (
        <EmptyStateContainer>
          <Empty description="No orders to display" />
        </EmptyStateContainer>
      )}
    </>
  );
};

export default UnfulfilledOrdersSection;